import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const mbbsImg2 = imageBaseUrl + "mbbsabroad.png";

const WhyStudyMbbsAbroad = () => {
  return (
    <>
      <MainContainer
        com1={
          <ContentContainer
            Header={
              <Header content={"Ready to Begin Your Global Journey?"} />
            }
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  "We help students in Greater Noida follow their dreams of studying in other countries. Our team makes the process easy and stress-free. With our expert advice and student-first approach, we guide you at every step—from choosing the best university to getting your admission. Let Taksheela be your trusted partner on this journey! Ready to take the first step? Book a free counseling session today and start planning your future with confidence!"
                }
              />
            }
            
           
          />
        }
        com2={<ImageContainer img={mbbsImg2} alt="MBBS Abroad Consultants In Delhi NCR"/>}
      />
    </>
  );
};
export default WhyStudyMbbsAbroad;
